import { Trans } from 'next-i18next'
import React from 'react'
import styled from '@emotion/styled'
import useConfig from '../../../config/state/use-config'

const Wrapper = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.1px;
  margin-bottom: 10px;
  text-align: justify;
  a {
    color: inherit;
    text-decoration: underline;
    white-space: nowrap;
    font-weight: bold;
  }
`

export default function TermsOfService() {
  const config = useConfig()
  const orgPrivacyPolicyLink = config.organization?.privacy_policy_url

  return (
    <Wrapper>
      <Trans
        i18nKey="termsOfService"
        components={{
          orgPrivacyPolicyLink: <a target="_blank" href={orgPrivacyPolicyLink} />,
          terms: <a target="_blank" href="https://pro.gofundme.com/c/legal/terms/" />,
          privacy: <a target="_blank" href="https://pro.gofundme.com/c/legal/privacy-notice/" />,
        }}
      />
    </Wrapper>
  )
}
